import type { Language } from "../shared/types";

const copy = {
  en: {
    nav: {
      workspace: "Seller Journey",
      dashboard: "Dashboard",
    },
    common: {
      synthetic: "Synthetic demo",
      publicEvidence: "Public evidence",
      openWorkspace: "Open mission control",
      learnSystem: "View portfolio dashboard",
    },
  },
  zh: {
    nav: {
      workspace: "卖家旅程",
      dashboard: "经营看板",
    },
    common: {
      synthetic: "合成演示",
      publicEvidence: "公开证据",
      openWorkspace: "进入任务中心",
      learnSystem: "查看经营看板",
    },
  },
} as const;

export function t(language: Language) {
  return copy[language];
}
